import React from 'react';
import { motion } from 'framer-motion';
import remoteaccess1 from './assets/images/remoteaccess.png';
import remoteaccess2 from './assets/images/remote2.png';

const SectionTitle = ({ children }) => (
  <h2 className="text-3xl font-bold text-white mb-8 flex items-center gap-3">
    <span className="text-secondary">/</span> {children}
  </h2>
);

export default function RemoteAccess({ onBack }) {
  return (
    <div className="max-w-5xl mx-auto px-6 py-20">
      <button
        type="button"
        onClick={onBack}
        className="inline-flex items-center gap-2 text-secondary hover:text-white font-mono text-sm mb-8"
      >
        ← Back to portfolio
      </button>

      <SectionTitle>Remote Access PC-Mobile Controller</SectionTitle>

      <div> 
              <img
                src={remoteaccess1}
                alt="Full interface preview"
                className="w-full h-96 object-cover rounded-2xl mb-12"
              />
            </div>

            <div className="grid gap-12 lg:grid-cols-[0.95fr_1fr] mb-14 items-start">
            <div className="rounded-3xl overflow-hidden border border-slate-700 bg-slate-800 w-fit mx-auto">
                <img
                src={remoteaccess2}
                alt="Remote Access PC-Mobile Controller interface preview"
                className="max-w-full h-auto object-contain"
                />
            </div>

        <div className="space-y-6 text-slate-400">
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-lg leading-8"
          >
            The Remote Access PC-Mobile Controller is a cross-platform application that allows users to remotely control their PC using a smartphone. It features a virtual touchpad, keyboard input, and on-screen joystick controls for easy gaming.
          </motion.p>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1 }}
            className="text-lg leading-8"
          >
            I developed the entire application from the ground up, including the mobile frontend and Windows backend. It runs entirely on the local network, and is made from as simple of code and minimal dependencies/libraries as possible, ensuring low latency and high performance for gaming and productivity tasks.
          </motion.p>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1 }}
            className="text-lg leading-8"
          >
            View source code on <a href="https://github.com/ethan-klassen/remote_access" target="_blank" rel="noreferrer" className="text-primary hover:underline">GitHub</a>, and download a beta release for Windows here: <a href="https://github.com/ethan-klassen/remote_access/releases" target="_blank" rel="noreferrer" className="text-primary hover:underline">Download Beta</a>
          </motion.p>
          <div className="rounded-3xl border border-slate-700 bg-slate-900 p-6">
            <h3 className="text-xl font-semibold text-white mb-3">Highlights</h3>
            <ul className="list-disc list-inside space-y-2 text-slate-400">
              <li>No install required on mobile (tested Android and iOS). Small single executable for Windows with minimal packages/libraries included.</li>
              <li>Low latency audio and video streaming for seamless remote control experience.</li>
              <li>Intuitive controls and responsive feedback.</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="rounded-3xl border border-slate-700 bg-slate-900 p-8 space-y-6">
        <div>
          <h3 className="text-2xl font-bold text-white mb-4">My role</h3>
          <p className="text-slate-400 leading-7">
            I developed the mobile frontend and Windows backend for the application, ensuring seamless integration and optimal performance across both platforms.
          </p>
        </div>
        <div className="grid gap-6 md:grid-cols-2">
          <div>
            <h4 className="text-white font-semibold mb-3">Visual design</h4>
            <p className="text-slate-400 leading-7">
              I designed the interface to be modern and intuitive, using clear visual hierarchy and consistent styling to enhance user experience.
            </p>
          </div>
          <div>
            <h4 className="text-white font-semibold mb-3">Technical work</h4>
            <p className="text-slate-400 leading-7">
              I used JavaScript and Python for the mobile and Windows applications respectively, implementing socket programming for real-time communication and ensuring efficient video encoding for smooth streaming.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
